import { render, staticRenderFns } from "./FormsPage.vue?vue&type=template&id=6b424c52&"
import script from "./FormsPage.vue?vue&type=script&lang=js&"
export * from "./FormsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports